<template>
    <div id="svg-spritesheet" v-html="spritesheetData"></div>
</template>

<script>
function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('@/assets/svg/icons/', true, /\.svg$/));

export default {
    data() {
        return {
            spritesheetData: '',
        };
    },
    methods: {
        fetchSpritesheetData() {
            const spritesheetEl = document.getElementById('svg-spritesheet');

            // If the spritesheet data already exists, i.e. the page has been
            // prerendered, load it into the vue model
            if (spritesheetEl && spritesheetEl.innerHTML !== '') {
                this.spritesheetData = spritesheetEl.innerHTML;
            } else {
                fetch('/assets/svg/icons.svg')
                    .then(res => res.text())
                    .then((data) => {
                        this.spritesheetData = data;
                    });
            }
        },
    },
    created() {
        this.fetchSpritesheetData();
    },
};
</script>

<style lang="scss">
#svg-spritesheet {
    display: none;
}
</style>
